module.exports = __webpack_public_path__ + "static/img/screenshot-approve-bidders.08bafc3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/screenshot-approve-bidders.png
// module id = tVN8
// module chunks = 1